import axios from "axios";
import { getBackendUrl } from "@/general";


const BASE_URL = "/archivo/api/";

export const dataGridProductos = async (context, page, search) => {
  const ENDPOINT = "producto";
  const parameters = {
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}${BASE_URL}${ENDPOINT}/`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const crudProductos = async (context, typeAction, id, requestData) => {
  const ENDPOINT = "producto";

  let response;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${ENDPOINT}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        response = await axios.put(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${ENDPOINT}/${id}`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "get": {
          const parameters = {
            "Modulo": requestData.modulo
          }
          response = await axios.get(
            `${source}${BASE_URL}${ENDPOINT}/`,
            {
              params: parameters,
              headers: paramsHeader
            }
          );
          break;
        }
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err
  }
}

export const dataGridPreciosProductos = async (context, page, search, filters) => {
  const ENDPOINT = "precio";
  const parameters = {
    ...filters,
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}${BASE_URL}${ENDPOINT}/`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const crudPreciosProductos = async (context, typeAction, id, requestData) => {
  const ENDPOINT = "precio";

  let response;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${ENDPOINT}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        response = await axios.put(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err
  }
}
